const userActions = {
  ACCEPTED_DBA_NAME_SUGGESTION: 'ACCEPTED_DBA_NAME_SUGGESTION',
  DECIDED_TO_USE_NEW_DBA_VERSION: 'DECIDED_TO_USE_NEW_DBA_VERSION',
  ACCEPTED_TO_USE_DBA_VERSION_FOUND: 'ACCEPTED_TO_USE_DBA_VERSION_FOUND',
  ACCEPTED_TO_EDIT_DBA_VERSION_FOUND: 'ACCEPTED_TO_EDIT_DBA_VERSION_FOUND',
  ACCEPTED_REMOVE_DBA_WITH_TRANSFERS: 'ACCEPTED_REMOVE_DBA_WITH_TRANSFERS',
  ACCEPTED_UPDATE_DBA_WITH_TRANSFERS: 'ACCEPTED_UPDATE_DBA_WITH_TRANSFERS',
  ACCEPTED_TO_REMOVE_CREATED_DBAS_ONLY_IN_THIS_BATCH: 'ACCEPTED_TO_REMOVE_CREATED_DBAS_ONLY_IN_THIS_BATCH'
};

module.exports = userActions;
